import {
  FETCH_AUDIO_TRACKS,
  SAVE_AUDIO_TRACKS_TRANSCRIPT,
  GET_USER_REPORT,
  SET_PAGE_NAME,
  FETCH_TRAINED_SENTENCE_COUNT_REPORT,
  FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT,
  FETCH_COMPARED_STATISTIC_REPORT,
  FETCH_SPECIFIC_AUDIO,
  UPLOAD_FILE_REQUEST,
  DOWNLOAD_HOURLY_REPORT,
  DOWNLOAD_CSV_FILE,
  GET_QA_TRANSCRIPTION_FILE,
  QA_DESICISION_TRANSCRIPTION_FILE,
  GET_SUPER_QA_TRANSCRIPTION_FILE,
  SUPER_QA_DESICISION_TRANSCRIPTION_FILE,
  LOGIN,
  LOGOUT,
  GET_TRANSCRIPT_LIST_TO_BE_RECORDED,
  FETCH_USER_LIST,
  INSERT_NEW_USER,
  UPDATE_USER_DETAILS,
  FILE_UPLOAD,
  FETCH_REJECT_REASON_LIST,
  FETCH_AUDITED_LIST_BY_USER,
  FETCH_ENGLISH_KEYWORDS, // Changes done by Santhosh Kumar G
  SAVE_KEYWORDS_SUGGESTIONS,
  SAVE_KEYWORDS_AUDIT,
  FETCH_KEYWORD_AUDIT,
  FETCH_DASHBOARD,
  GET_QA_AUDIO,
  QA_DESICISION_AUDIO_FILE,
  GET_SQA_AUDIO,
  SQA_DESICISION_AUDIO_FILE,
  FETCH_LANGUAGES,
  FETCH_USER_TYPE,
  DOWNLOAD_RECORDING_PENDING_REPORT,
  FETCH_PRODUCTS,
  FETCH_TEAMS,
  FETCH_AUDIT_USER_LIST,
  SAVE_KEYWORD,
  REGISTER,
  GET_COLLEGE_LIST,
  UPDATE_EXISTING_KEYWORD,
} from "./../constants/constants";

export function fetchAudioTracks(
  username,
  start_date,
  end_date,
  start_page,
  end_page
) {
  return {
    type: FETCH_AUDIO_TRACKS,
    object: { username, start_date, end_date, start_page, end_page },
  };
}

export function isUserLoggedIn(username, password) {
  return {
    type: LOGIN,
    object: { username, password },
  };
}

export function saveAudioTracks(item) {
  return {
    type: SAVE_AUDIO_TRACKS_TRANSCRIPT,
    object: {
      //file_path: item.item.file_path,
      transcript_id: item.item.id,
      transcript: item.transcript,
      language: item.language,
      user: item.user,
    },
  };
}

export function fetchUserReport() {
  return {
    type: GET_USER_REPORT,
  };
}

export function fetchUserLanguages() {
  return {
    type: FETCH_LANGUAGES,
  };
}

export function fetchUserTypes() {
  return {
    type: FETCH_USER_TYPE,
  };
}

export function fetchProducts() {
  return {
    type: FETCH_PRODUCTS,
  };
}

export function fetchTeams() {
  return {
    type: FETCH_TEAMS,
  };
}

export function fetchEnglishKeywords(userId) {
  // Changes done by Santhosh Kumar G
  return {
    type: FETCH_ENGLISH_KEYWORDS,
    userId,
  };
}

export function fetchUserwiseData(userId) {
  return {
    type: FETCH_DASHBOARD,
    userId,
  };
}
export function fetchKeywordsAudit(userId) {
  // Changes done by Santhosh Kumar G
  return {
    type: FETCH_KEYWORD_AUDIT,
    userId,
  };
}
export function saveKeywordSuggestions(suggestionObj) {
  // Changes done by Santhosh Kumar G
  return {
    type: SAVE_KEYWORDS_SUGGESTIONS,
    suggestionObj,
  };
}
export function saveKeywordAudit(auditObj) {
  // Changes done by Santhosh Kumar G
  return {
    type: SAVE_KEYWORDS_AUDIT,
    auditObj,
  };
}
export function setPageName(pageName) {
  return {
    type: SET_PAGE_NAME,
    payload: pageName,
  };
}

export function fetchTrainedCountReport(startPage, endPage) {
  return {
    type: FETCH_TRAINED_SENTENCE_COUNT_REPORT,
    payload: { startPage, endPage },
  };
}

export function fetchTranscriptedReport(startPage, endPage) {
  return {
    type: FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT,
    payload: { startPage, endPage },
  };
}

export function fetchComparedStatisticReport() {
  return {
    type: FETCH_COMPARED_STATISTIC_REPORT,
  };
}

export function fetchSpecificFileName(name) {
  return {
    type: FETCH_SPECIFIC_AUDIO,
    payload: name,
  };
}

export function fetchAuditUserList(LoginId) {
  return {
    type: FETCH_AUDIT_USER_LIST,
    payload: LoginId,
  };
}

export function isAudioUploaded(wavid, userId, file) {
  return {
    type: UPLOAD_FILE_REQUEST,
    payload: { wavid, userId, file },
  };
}

export function getHourlyReport(type) {
  return {
    type: DOWNLOAD_HOURLY_REPORT,
    payload: type,
  };
}

export function getRecordingPendingReport(type) {
  return {
    type: DOWNLOAD_RECORDING_PENDING_REPORT,
    payload: type,
  };
}

export function getCSVFILE(URL, start_date, end_date, flagValue, searchValue,REMOTE_ADDR) {
  return {
    type: DOWNLOAD_CSV_FILE,
    payload: { URL, start_date, end_date, flagValue, searchValue,REMOTE_ADDR },
  };
}

export function getTranscriptTobeDownloaded(userid) {
  return {
    type: GET_TRANSCRIPT_LIST_TO_BE_RECORDED,
    payload: { userid },
  };
}

export function isLogoutSuccess() {
  return {
    type: LOGOUT,
    payload: "",
  };
}

export function fetchQaAudio(userId, userType) {
  return {
    type: GET_QA_AUDIO,
    payload: { userId, userType },
  };
}

export function fetchSQAAudio(
  userId,
  start_date,
  end_date,
  searchValue,
  selectedOption
) {
  return {
    type: GET_SQA_AUDIO,
    payload: { userId, start_date, end_date, searchValue, selectedOption },
  };
}

export function saveKeyword(userId, productId, language, keyword) {
  return {
    type: SAVE_KEYWORD,
    payload: { userId, productId, language, keyword },
  };
}

export function fetchQATranscriptionAudio(userId, userType) {
  return {
    type: GET_QA_TRANSCRIPTION_FILE,
    payload: { userId, userType },
  };
}

export function fetchSQATranscriptionAudio(
  userId,
  start_date,
  end_date,
  searchValue,
  selectedOption
) {
  return {
    type: GET_SUPER_QA_TRANSCRIPTION_FILE,
    payload: { userId, start_date, end_date, searchValue, selectedOption },
  };
}

export function QATranscriptionDecision(
  userId,
  transcriptId,
  quality,
  transcript,
  error_id,
  userType
) {
  return {
    type: QA_DESICISION_TRANSCRIPTION_FILE,
    payload: {
      transcriptId,
      userId,
      quality,
      transcript,
      error_id,
      userType,
    },
  };
}

export function SQATranscriptionDecision(
  userId,
  transcriptId,
  quality,
  transcript,
  error_id,
  userType
) {
  return {
    type: SUPER_QA_DESICISION_TRANSCRIPTION_FILE,
    payload: {
      transcriptId,
      userId,
      quality,
      transcript,
      error_id,
      userType,
    },
  };
}

export function QAAudioDecision(
  userId,
  transcriptId,
  quality,
  transcript,
  error_id,
  userType
) {
  return {
    type: QA_DESICISION_AUDIO_FILE,
    payload: {
      transcriptId,
      userId,
      quality,
      transcript,
      error_id,
      userType,
    },
  };
}

export function SQAAudioDecision(
  userId,
  transcriptId,
  quality,
  transcript,
  error_id,
  userType
) {
  return {
    type: SQA_DESICISION_AUDIO_FILE,
    payload: {
      transcriptId,
      userId,
      quality,
      transcript,
      error_id,
      userType,
    },
  };
}

export function superQAAudioDecision(
  userId,
  transcriptId,
  quality,
  transcript,
  error_id,
  userType
) {
  return {
    type: SUPER_QA_DESICISION_TRANSCRIPTION_FILE,
    payload: {
      transcriptId,
      userId,
      quality,
      transcript,
      error_id,
      userType,
    },
  };
}

export function fetchUserList() {
  return {
    type: FETCH_USER_LIST,
    payload: "",
  };
}

export function fetchCollegeList() {
  return {
    type: GET_COLLEGE_LIST,
    payload: "",
  };
}

export function fetchRejectReajonList() {
  return {
    type: FETCH_REJECT_REASON_LIST,
    payload: "",
  };
}

export function insertNewUser(
  LoginId,
  Password,
  BaseLanguage,
  OtherLanguages,
  UserPrivilege,
  Createdby,
  EmployeeName,
  ProductIds,
  TeamId
) {
  return {
    type: INSERT_NEW_USER,
    payload: {
      LoginId,
      Password,
      BaseLanguage,
      OtherLanguages,
      UserPrivilege,
      Createdby,
      EmployeeName,
      ProductIds,
      TeamId,
    },
  };
}

export function registerNewUser(
  LoginId,
  Password,
  BaseLanguage,
  OtherLanguages,
  UserPrivilege,
  Createdby,
  EmployeeName,
  ProductIds,
  TeamId,
  CollegeId
) {
  return {
    type: REGISTER,
    payload: {
      LoginId,
      Password,
      BaseLanguage,
      OtherLanguages,
      UserPrivilege,
      Createdby,
      EmployeeName,
      ProductIds,
      TeamId,
      CollegeId,
    },
  };
}
export function updateUserDetails(toBeUpdated, ut, up, TeamId, modifiedBy) {
  return {
    type: UPDATE_USER_DETAILS,
    payload: { toBeUpdated, ut, up, TeamId, modifiedBy },
  };
}

export function requestToFileUpload(file) {
  return {
    type: FILE_UPLOAD,
    payload: file,
  };
}

export function getAuditedListByUser(user_id, startdate, enddate) {
  return {
    type: FETCH_AUDITED_LIST_BY_USER,
    object: { user_id, startdate, enddate },
  };
}

export function updateExistingKeywords(keywords, flag) {
  return {
    type: UPDATE_EXISTING_KEYWORD,
    payload: { keywords, flag },
  };
}
